import { render, staticRenderFns } from "./AdvertiseBuffet.vue?vue&type=template&id=359adf0b&"
import script from "./AdvertiseBuffet.vue?vue&type=script&lang=js&"
export * from "./AdvertiseBuffet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports